import { bootstrapApplication, createApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { AppComponent } from './app/app.component';
import { LoginFormComponent } from './app/widgets/login-form/login-form.component';
import { SignupFormComponent } from './app/widgets/signup-form/signup-form.component';
import { ForgotPasswordFormComponent } from './app/widgets/forgot-password-form/forgot-password-form.component';
import { ApplicationRef, importProvidersFrom } from '@angular/core';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { authReducer } from './app/store/auth.reducer';
import { AuthEffects } from './app/store/auth.effects';
import { AuthService } from './app/store/auth.service';
import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { CommonService } from './app/services/common.service';
import { IconService } from './app/services/icon.service';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './app/interceptors/auth.interceptor';

// // Instead of bootstrapping to DOM, create a detached application
// createApplication({
//   providers: [
//     importProvidersFrom(HttpClientModule),
//     provideStore({ auth: authReducer }),
//     provideEffects([AuthEffects]),
//     provideRouter([], withHashLocation()),
//     provideAnimations(),
//     AuthService,
//     CommonService
//   ]
// }).then(appRef => {
//   // Register the custom elements
//   // Login widget
//   const loginElement = createCustomElement(LoginComponent, {
//     injector: appRef.injector
//   });
//   customElements.define('login-widget', loginElement);

//   // Signup widget
//   const signupElement = createCustomElement(SignupComponent, {
//     injector: appRef.injector
//   });
//   customElements.define('signup-widget', signupElement);

//   console.log('Custom elements registered successfully');
// }).catch(err => console.error('Error creating application:', err));

// Bootstrap to DOM if app-root exists
if (document.querySelector('app-root')) {
  bootstrapApplication(AppComponent, {
    providers: [
      provideHttpClient(withInterceptors([authInterceptor])),
      provideStore({ auth: authReducer }),
      provideEffects([AuthEffects]),
      provideRouter([], withHashLocation()),
      provideAnimations(),
      AuthService,
      CommonService,
      IconService
    ]
  }).catch(err => console.error('Error bootstrapping application:', err));
} else {
  // Create a detached application for web components
  createApplication({
    providers: [
      provideHttpClient(withInterceptors([authInterceptor])),
      provideStore({ auth: authReducer }),
      provideEffects([AuthEffects]),
      provideRouter([], withHashLocation()),
      provideAnimations(),
      AuthService,
      CommonService,
      IconService
    ]
  }).then(appRef => {
    // Initialize icon service to register icons
    const iconService = appRef.injector.get(IconService);
    
    // Register the custom elements
    // Login widget
    const loginElement = createCustomElement(LoginFormComponent, {
      injector: appRef.injector
    });
    customElements.define('login-widget', loginElement);

    // Signup widget
    const signupElement = createCustomElement(SignupFormComponent, {
      injector: appRef.injector
    });
    customElements.define('signup-widget', signupElement);

    // Forgot password widget
    const forgotPasswordElement = createCustomElement(ForgotPasswordFormComponent, {
      injector: appRef.injector
    });
    customElements.define('forgot-password-widget', forgotPasswordElement);

    console.log('Custom elements registered successfully');
  }).catch(err => console.error('Error creating application:', err));
}

